const clean = (value) => String(value || '').trim();

const languageBase = (language) => String(language || 'en').toLowerCase().split('-')[0];

const CTA_BY_LANGUAGE = {
  pt: 'Descarrega o audioguia e ouve a história completa.',
  en: 'Download the audio guide and hear the complete story.',
  es: 'Descarga la audioguía y escucha la historia completa.',
  fr: `Télécharge l'audioguide et écoute toute l'histoire.`,
  de: 'Lade den Audioguide herunter und höre die ganze Geschichte.',
  it: `Scarica l'audioguida e ascolta la storia completa.`,
  nl: 'Download de audiogids en luister naar het volledige verhaal.',
  ru: 'Скачайте аудиогид и послушайте историю полностью.',
  bg: 'Изтеглете аудиогида и чуйте цялата история.',
};

const LINK_LABEL_BY_LANGUAGE = {
  pt: 'Audioguia',
  en: 'Audio guide',
  es: 'Audioguía',
  fr: 'Audioguide',
  de: 'Audioguide',
  it: 'Audioguida',
  nl: 'Audiogids',
  ru: 'Аудиогид',
  bg: 'Аудиогид',
};

const STORY_LINK_LABEL_BY_LANGUAGE = {
  pt: 'Vê mais em',
  en: 'See more at',
  es: 'Ver más en',
  fr: 'Voir plus sur',
  de: 'Mehr unter',
  it: 'Scopri di più su',
  nl: 'Lees meer op',
  ru: 'Узнайте больше на',
  bg: 'Виж повече на',
};

const CTA_PATTERNS = {
  pt: /\b(?:descarrega|experimenta|abre|ouve|acede)\b/iu,
  en: /\b(?:download|try|open|listen)\b/iu,
  es: /\b(?:descarga|prueba|abre|escucha)\b/iu,
  fr: /\b(?:télécharge|essaie|ouvre|écoute)\b/iu,
  de: /\b(?:lade|probiere|öffne|höre)\b/iu,
  it: /\b(?:scarica|prova|apri|ascolta)\b/iu,
  nl: /\b(?:download|probeer|open|luister)\b/iu,
  ru: /\b(?:скачайте|попробуйте|откройте|послушайте)\b/iu,
  bg: /\b(?:изтеглете|опитайте|отворете|чуйте)\b/iu,
};

export const ensureExplicitAudioGuideCta = (text, language) => {
  const content = clean(text);
  const base = languageBase(language);
  const pattern = CTA_PATTERNS[base] || CTA_PATTERNS.en;
  if (pattern.test(content)) return content;
  return [content, CTA_BY_LANGUAGE[base] || CTA_BY_LANGUAGE.en].filter(Boolean).join('\n\n');
};

export const ensureCaptionLink = (caption, url, language) => {
  const content = clean(caption);
  const approvedUrl = clean(url);
  if (!approvedUrl || content.includes(approvedUrl)) return content;
  const base = languageBase(language);
  return [content, `${LINK_LABEL_BY_LANGUAGE[base] || LINK_LABEL_BY_LANGUAGE.en}: ${approvedUrl}`]
    .filter(Boolean)
    .join('\n\n');
};

export const ensureStoryCaptionLink = (caption, url, language) => {
  const content = clean(caption);
  const approvedUrl = clean(url);
  if (!approvedUrl || content.includes(approvedUrl)) return content;
  const base = languageBase(language);
  return [content, `${STORY_LINK_LABEL_BY_LANGUAGE[base] || STORY_LINK_LABEL_BY_LANGUAGE.en} ${approvedUrl}`]
    .filter(Boolean)
    .join('\n\n');
};

export const ensureCaptionHashtags = (caption, hashtags) => {
  const content = clean(caption);
  const approvedHashtags = clean(hashtags).split(/\s+/).filter((item) => item.startsWith('#'));
  const missingHashtags = approvedHashtags.filter((hashtag) => !content.toLowerCase().includes(hashtag.toLowerCase()));
  return [content, missingHashtags.join(' ')].filter(Boolean).join('\n\n');
};

export const finalizeSocialCaption = (caption, { language, url, mentions = '' } = {}) => {
  let content = ensureExplicitAudioGuideCta(caption, language);
  content = ensureCaptionLink(content, url, language);
  const requiredMentions = clean(mentions).split(/\s+/).filter((item) => item.startsWith('@'));
  const missingMentions = requiredMentions.filter((mention) => !content.includes(mention));
  return [content, missingMentions.join(' ')].filter(Boolean).join('\n\n');
};
